export enum ESourceType {
  EXAMPLE_SOURCE = 'example_source',
  EXTERNAL_PAGE = 'external_page',
  SHOPIFY = 'shopify',
  SHOPWARE_5 = 'shopware5',
  SHOPWARE_6 = 'shopware6',
}
export enum EBundleName {
  EXAMPLE = 'example',
  EXTERNAL_PAGE = 'external_page',
  SHOPIFY_CUSTOM_PIXEL = 'shopify_customPixel',
  SHOPIFY_DEFAULT = 'shopify_default',
  SHOPWARE5_DEFAULT = 'shopware5_default',
  SHOPWARE6_DEFAULT = 'shopware6_default',
  UNKNOWN = 'UNKNOWN',
  VANILLA = 'vanilla',
}

export type ISourceBundle = {
  init: () => void;
  name: EBundleName;
  sourceInitConfig?: any;
  type: ESourceType;
  wtagFunction?: (...args: any[]) => void;
};
